module.exports = __webpack_public_path__ + "img/18_99.480035f0.png";